import { cn } from './cn';

export type ControlSize = 'sm' | 'md';

/**
 * Shared look for text inputs, textareas, and selects. Text is 16px on small
 * screens so iOS does not zoom into a focused field, and 14px from `sm` up.
 */
export const controlStyles = ({
  size = 'md',
  mono = false,
  className,
}: {
  size?: ControlSize;
  mono?: boolean;
  className?: string;
} = {}): string =>
  cn(
    'block w-full min-w-0 rounded-md border border-border-strong bg-surface text-base text-fg shadow-sm transition-colors duration-150 sm:text-sm',
    'placeholder:text-fg-subtle',
    'enabled:hover:border-fg-subtle/70',
    'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-fg-subtle disabled:shadow-none',
    'aria-[invalid=true]:border-danger',
    size === 'sm' ? 'h-8 px-2.5' : 'h-9 px-3',
    mono && 'font-mono',
    className
  );
